import React, { useCallback, useEffect, useState } from 'react';
import { TypeUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useCreateSbatGroupLectureContentMutation } from '@classCreation/services/sbatGroupLectureContentService';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LectureContentInput from '../LectureContentInput';
import useSbatGroupConfirmation from '@classCreation/hooks/useSbatGroupConfirmation';

export default function CreateSbatGroupLectureContentForm({
  sbatGroup,
  contentType,
  onSuccess,
  label,
}) {
  const [lectureContent, setLectureContent] = useState();
  const [createLectureContent, { isSuccess, error, isLoading: isCreating }] =
    useCreateSbatGroupLectureContentMutation();

  const handleCreateContent = useCallback(() => {
    createLectureContent({
      sbatGroupId: sbatGroup.id,
      content: lectureContent,
    });
  }, [createLectureContent, lectureContent, sbatGroup.id]);

  const handleSubmit = useSbatGroupConfirmation(handleCreateContent, sbatGroup);

  const handleOnChange = useCallback((newContent) => {
    setLectureContent(newContent);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lecture content is successfully created!');
      onSuccess();
    }
    if (error) {
      if (TypeUtils.isString(error?.data?.message)) {
        cogoToast.error(error?.data?.message);
      } else {
        cogoToast.error(
          'There was some problem in creating the lecture content. Please try again later!'
        );
      }
    }
  }, [error, isSuccess, onSuccess]);

  return (
    <Form onSubmit={handleSubmit}>
      <LectureContentInput
        contentType={contentType}
        value={lectureContent}
        onChange={handleOnChange}
        placeholder={`Enter ${label}`}
      />
      <FieldErrors
        name="content"
        errors={TypeUtils.isObject(error?.data?.message) && error.data.message}
      />
      <Tappable
        className="btn btn-primary m-v-xxs"
        disabled={isCreating}
        component="button"
        type="submit"
      >
        Create {label}
      </Tappable>
    </Form>
  );
}
